export default __webpack_public_path__ + "static/media/5.18342ec1.jpg";